import SignUpFamily from './SignUpFamily';
export default SignUpFamily;